import { render } from "./Slides.vue?vue&type=template&id=7ea63f4d&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import "./slides.scss?vue&type=style&index=0&id=7ea63f4d&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea63f4d"]])

export default __exports__